import type { CarrierCarrierInfo } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type { CarrierMethodsView, SummaryCarrier } from './carriers-and-methods.types';

type CarriersAndMethodsResponse<V extends CarrierMethodsView> = V extends 'summary'
  ? SummaryCarrier[]
  : CarrierCarrierInfo[];

export const carriersAndMethods = {
  search: {
    queryKey: 'orchestration-service/carriers-and-methods',
    configurationType: 'cached' as const,
    fn: async <V extends CarrierMethodsView = 'full'>(view?: V): Promise<CarriersAndMethodsResponse<V>> => {
      const resolvedView = view ?? 'full';
      const { data } = await GatewayAxiosClient.get<CarriersAndMethodsResponse<V>>(
        '/ui-orchestration-proxy/api/v1/carrier/carrier-and-methods',
        { params: resolvedView === 'summary' ? { view: 'summary' } : undefined },
      );

      return data;
    },
  },
};
